<template>
  <div class="nodata">
    <img :src="require('@/assets/nodata.png')" class="nodata-icon">
    <div v-if="message" class="nodata-text" v-html="message"></div>
    <van-button v-if="btntext" class="nodata-btn" @click="onOk">
      {{btntext}}
    </van-button>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props: {
    message: {
      type: String,
      default: ''
    },
    btntext: {
      type: String,
      default: ''
    },
    callback: {
      type:Function,
      default:null
    },
  },
  data(){
    return {
    };
  },
  mounted: function()
  {

  },
  methods: {
    onOk(){
      this.callback && this.callback();
    }
  }
}
</script>

<style scoped>
.nodata{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 100px;
}
.nodata-icon{
  width: 160px;
  height: 160px;
}
.nodata-text{
  margin-top: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #20253F;
  font-weight: 400;
}
.nodata-btn{
  margin-top: 16px;
  width: 163px;
  height: 44px;
  background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
}
</style>